export default __webpack_public_path__ + "static/media/2-3.3a5855b4.mp3";